export async function initTelInputs() {
  const inputs = document.querySelectorAll('input[type="tel"]');
  if (!inputs.length) return;

  const Inputmask = await import('inputmask').then((r) => r.default);
  inputs.forEach((input) => {
    if (input.inputmask) return;

    Inputmask({
      mask: '+99999999999[9{1,3}]',
      showMaskOnHover: false,
      showMaskOnFocus: false,
    }).mask(input);
  });
}
